import { ConciergeBell, Gem, Globe } from "lucide-react";
import { FadeUp, SectionIntro } from "../Reveal";
import { LuxButton } from "../LuxButton";
import { useUI } from "@/context/UIContext";

const VALUES = [
  {
    icon: Globe,
    title: "Global reach",
    desc: "Access to the world's most exclusive connections.",
  },
  {
    icon: ConciergeBell,
    title: "Tailored service",
    desc: "Every request shaped precisely to your needs.",
  },
  {
    icon: Gem,
    title: "Exceptional value",
    desc: "Results that consistently exceed expectations.",
  },
];

export const Values = () => {
  const { openEnquiry } = useUI();
  return (
    <section data-testid="values-section" className="bg-[#080808] py-24 md:py-32">
      <SectionIntro
        eyebrow="Why us"
        title="What sets us apart"
        subtitle="We operate on three principles that define everything we do."
      />
      <div className="mx-auto mt-16 grid max-w-[1150px] gap-14 px-6 md:grid-cols-3 md:gap-0 lg:px-12">
        {VALUES.map((v, i) => (
          <FadeUp
            key={v.title}
            delay={i * 0.12}
            className={`group flex flex-col items-center text-center md:px-10 ${
              i > 0 ? "md:border-l md:border-[rgba(200,164,93,0.15)]" : ""
            }`}
          >
            <v.icon
              className="h-8 w-8 text-champagne transition-all duration-500 ease-out group-hover:-translate-y-1 group-hover:text-champagne-light"
              strokeWidth={0.9}
            />
            <h3 className="mt-7 font-serif text-[26px] font-medium text-ivory transition-colors duration-500 group-hover:text-champagne-light">
              {v.title}
            </h3>
            <p className="mt-3 max-w-[240px] text-[13px] font-light leading-relaxed text-ivory-muted">
              {v.desc}
            </p>
          </FadeUp>
        ))}
      </div>
      <FadeUp delay={0.2} className="mt-16 flex items-center justify-center gap-4 px-6">
        <LuxButton to="/concierge" testId="values-explore-button">
          Explore
        </LuxButton>
        <LuxButton
          variant="text"
          arrow
          onClick={() => openEnquiry("Concierge")}
          testId="values-learn-more-button"
        >
          Learn More
        </LuxButton>
      </FadeUp>
    </section>
  );
};
